import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { EnumDescriptor } from '../../enum-descriptor';
import { TemplateState } from '@proxy/templates';

@Component({
    selector: 'app-evaluation-template-state-dropdown',
    templateUrl: './evaluation-template-state-dropdown.component.html',
    standalone: false
})
export class EvaluationTemplateStateDropdownComponent  extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() isReadOnly: boolean;
  @Input() evaluationTemplateState: TemplateState;
  @Input() isGridView = false;

  @Output() changeEvaluationTemplateState = new EventEmitter<TemplateState>();

  evaluationTemplateStates: EnumDescriptor[];

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.isNullOrUndefined(this.evaluationTemplateStates)) {
      if (this.isGridView) {
        this.evaluationTemplateState = TemplateState.Active;
      } else {
        this.evaluationTemplateState = TemplateState.Inactive;
      }
    }

    this.loadEvaluationTemplateState();
    this.onSelected();
  }

  loadEvaluationTemplateState(): void {
    this.evaluationTemplateStates = this.getEnumOptions(TemplateState, false);
  }

  onSelected(): void {
    this.changeEvaluationTemplateState.emit(this.evaluationTemplateState);
  }
}
